import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '@/store/store';
import { getCredentialsFromLS } from '../localstorage';

const listOfOpenEndpoints = ['connect'];

// Create our baseQuery instance
const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  prepareHeaders: (headers, { getState, endpoint }) => {
    // By default, if we have a token in the store, let's use that for authenticated requests
    let token = (getState() as RootState).authReducer.accessToken;
    if (!token) {
      let credentials = getCredentialsFromLS();
      if (credentials) {
        token = credentials.accessToken;
      }
    }

    if (window.location.href.includes('connections')) {
      return;
    }

    // this is a workaround to remove token from request for some endpoints
    // for it to work set 'Authorization' header in endpoint declaration and it will remove it here
    if (headers.has('Authorization')) {
      headers.delete('Authorization');
      return;
    }

    if (token && !listOfOpenEndpoints.includes(endpoint)) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const api = createApi({
  baseQuery: baseQuery,
  tagTypes: [
    'Auth',
    'Users',
    'Roles',
    'RetailDataProviders',
    'UserProfiles',
    'Companies',
    'Offices',
    'AdminBudgets',
    'AdminBudgetItems',
    'Properties',
    'MediaLibraryImages',
    'CustomerCampaigns',
    'CustomerAdSets',
    'CustomerCreatives',
    'CustomerBudgets',
    'CustomersOrders',
    'CustomerAdvertisements',
    'CompanyPlatformsConfigs',
    'OfficePlatformsConfigs',
    'CompanyAutoCreationSettings',
    'CompanyBranding',
    'CustomerUser',
    'ApplicationLogs',
    'CustomerMoovly',
    'AdvertisementsAdmin',
    'Categories',
    'Medialists',
    'Audiences',
    'Filters',
    'Products',
    'AdminProductItems',
    'CustomerProductsBudgets',
    'Clients',
  ],
  endpoints: () => ({}),
});

export const TypeIdsDefinitions = Object.freeze({
  listTypeId: 'LIST',
  partialListTypeId: 'PARTIAL-LIST',
});
